// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"thumb-list-component_listContainer__3f1_O","fullWidth":"thumb-list-component_fullWidth__XGVpe"};